/**
 * Compact header URL-parameter toggle.
 *
 * Liquid cannot read URL query parameters, so the campaign PDP (identified by a
 * query parameter such as `pdp_template=campaign-silk`) needs its header swap
 * handled client-side: hide the standard header and reveal the compact header.
 *
 * This script is loaded synchronously from compact-header.liquid, which is
 * emitted BEFORE the standard header in the layout. Running here — before
 * #shopify-section-header is parsed — lets us hide it prior to first paint, so
 * there is no flash of the standard header.
 *
 * The trigger condition is read from the compact header's `data-url-condition`
 * attribute (`key=value` = exact match, bare `key` = present with any value).
 */
(function () {
  try {
    var header = document.querySelector('.header--compact[data-url-condition]');
    if (!header) return;

    var condition = (header.getAttribute('data-url-condition') || '').replace(/^[?&]+/, '').trim();
    if (!condition) return;

    var params = new URLSearchParams(window.location.search);
    var separator = condition.indexOf('=');

    var isMatch;
    if (separator === -1) {
      isMatch = params.has(condition);
    } else {
      var key = condition.slice(0, separator).trim();
      var value = condition.slice(separator + 1).trim();
      isMatch = params.get(key) === value;
    }
    if (!isMatch) return;

    header.classList.add('is-active');

    var style = document.createElement('style');
    style.setAttribute('data-compact-header-toggle', '');
    style.appendChild(document.createTextNode('#shopify-section-header{display:none !important;}'));
    (document.head || document.documentElement).appendChild(style);

    document.documentElement.classList.add('pdp-compact-header');
  } catch (error) {
  }
})();
